import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  category: window.location.pathname === '/confirmation' ? 'confirmation' : 'frontpage'
}

const page = createReducer(initialState, {})

export default page
